// eK Score Customer self-signup (the eK Score Marketplace's counterparties: banks, input
// suppliers, buyers, insurers and so on). The persona itself comes from the backend's
// sign-up metadata like every other persona (persona_types.show_on_sign_up); this file only
// holds what the sign-up form adds for it.

/** The persona name as the sign-up metadata returns it in `userTypes[].typeName`. */
export const SCORE_CUSTOMER_PERSONA = 'SCORE_CUSTOMER';

/** What the role dropdown shows instead of the raw persona name. */
export const SCORE_CUSTOMER_LABEL = 'eK Score Customer';

/** Organisation types, in the order the form lists them. `value` is what the backend stores. */
export const SCORE_CUSTOMER_TYPES = [
  { value: 'BANK', label: 'Bank' },
  { value: 'NBFC', label: 'NBFC' },
  { value: 'MFI', label: 'MFI' },
  { value: 'INPUT_SUPPLIER', label: 'Input supplier' },
  { value: 'BUYER_AND_TRADER', label: 'Buyer / trader' },
  { value: 'AGRO_PROCESSOR', label: 'Agro-processor' },
  { value: 'INSURANCE', label: 'Insurance' },
  { value: 'TRAINING_AND_EXTENSION', label: 'Training & extension' },
  { value: 'CONSULTING', label: 'Consulting' },
  { value: 'AGRITECH', label: 'AgriTech' },
  { value: 'LOGISTICS', label: 'Logistics' },
];

/**
 * The request field names the two values are sent under, inside `organisationDetail` of the
 * sign-up payload (POST /eklink/user/signUp). One place, so a rename on the backend is a one-line
 * change here. `organisationName` is sent for an individual too: it is the organisation they work
 * for. (The integrator whose ecosystem gets the pending membership is the usual
 * `organisationDetail.selectedIntegrators[0]`, picked on the Ecosystem step.)
 */
export const SCORE_CUSTOMER_SIGNUP_FIELDS = {
  customerType: 'scoreCustomerType',
  organizationName: 'organisationName',
};

export const isScoreCustomerPersona = (typeName) =>
  String(typeName || '').trim().toUpperCase() === SCORE_CUSTOMER_PERSONA;

/** The role dropdown label for a persona: the score customer gets a readable name. */
export const signupPersonaLabel = (typeName) =>
  isScoreCustomerPersona(typeName) ? SCORE_CUSTOMER_LABEL : typeName;

/** The organisation-detail fields to merge into the sign-up payload for a score customer. */
export const buildScoreCustomerSignupFields = (formData) => {
  const organizationName =
    formData.registrationType === 'organization'
      ? (formData.organisationName || '').trim()
      : (formData.scoreCustomerOrganizationName || '').trim();

  return {
    [SCORE_CUSTOMER_SIGNUP_FIELDS.customerType]: formData.scoreCustomerType || null,
    [SCORE_CUSTOMER_SIGNUP_FIELDS.organizationName]: organizationName || null,
  };
};

/** Only an absolute http(s) URL is accepted as a return address; anything else is dropped. */
export const safeReturnUrl = (value) => {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.toString() : null;
  } catch (error) {
    return null;
  }
};

/**
 * `?persona=SCORE_CUSTOMER` preselects that persona once the country's personas load;
 * `?returnUrl=` (or `redirectUri`, the name the shared web sign-in uses) is where the
 * "registration received" screen sends the user back to.
 */
export const readSignupUrlParams = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  const persona = (params.get('persona') || '').trim().toUpperCase() || null;
  const returnUrl = safeReturnUrl(params.get('returnUrl') || params.get('redirectUri'));
  return { persona, returnUrl };
};
